import { Container } from '../../DIContainer';
import { initializeAuthUseCases } from './auth/auth';
import { initializeBookmarkUseCases } from './bookmark/bookmark';
import { initializeChannelUseCase } from './channel/channel';
import { initializeChannelSeriesUseCase } from './channelSeriesHistory/channelSeriesHistory';
import { initializeCmsUseCases } from './cms/cms';
import { initializeDiscountUseCases } from './discount/discount';
import { initializeEntitlementUseCases } from './entitlement/entitlement';
import { initializeGatewayUseCases } from './gateway/gateway';
import { initializeGeoLocationUseCases } from './geoLocation/geoLocation';
import { initializeMpxUseCases } from './mpx/mpx';
import { initializeNotificationsUseCases } from './notifications/notifications';
import { initializePopcornUseCases } from './popcorn/popcorn';
import { initializeProfileUseCases } from './profile/profile';
import { initializeReminderUseCases } from './reminder/reminder';
import { initializeSlpUseCases } from './slp/slp';
import { initializeSubscriptionUseCases } from './subscription/subscription';
import { initializeThinkAnalyticsUseCases } from './thinkAnalytics/thinkAnalytics';
import { initializeUserUseCases } from './user/user';
import { initializeZendeskUseCases } from './zendesk/zendesk';
import { initializeLearnActionUseCases } from './learnAction/learnAction';
import { initializePaymentConfigUseCases } from './paymentConfig/paymentConfig';
import { initializeDeviceUseCases } from './Device/Device';
import { initializeUserIdentityUseCases } from './UserIdentity/userIdentity';
import { initializeCustomConfigurationUseCases } from './customConfiguration/customConfiguration';
import { initializeUserRegistrationUseCases } from './userRegistration/userRegistration';
import { initializeCmsCarouselUseCases } from './cmsCarousel/cmsCarousel';
import { initializeStreamHarnessUseCases } from './streamharness/streamharness';
import { initializeRewardUseCases } from './rewardSystem/reward';

export const initializeUseCases = (container: Container) => {
    initializeAuthUseCases(container);
    initializeBookmarkUseCases(container);
    initializeCmsUseCases(container);
    initializeChannelUseCase(container);
    initializeChannelSeriesUseCase(container);
    initializeDeviceUseCases(container);
    initializeDiscountUseCases(container);
    initializeEntitlementUseCases(container);
    initializeGatewayUseCases(container);
    initializeGeoLocationUseCases(container);
    initializeMpxUseCases(container);
    initializeNotificationsUseCases(container);
    initializePopcornUseCases(container);
    initializeProfileUseCases(container);
    initializeReminderUseCases(container);
    initializeSlpUseCases(container);
    initializeSubscriptionUseCases(container);
    initializeThinkAnalyticsUseCases(container);
    initializeUserUseCases(container);
    initializeUserIdentityUseCases(container);
    initializeZendeskUseCases(container);
    initializeLearnActionUseCases(container);
    initializePaymentConfigUseCases(container);
    initializeCustomConfigurationUseCases(container);
    initializeUserRegistrationUseCases(container);
    initializeCmsCarouselUseCases(container);
    initializeStreamHarnessUseCases(container);
    initializeRewardUseCases(container);
};
